/** Audit log (`audit:view`). Newest first, cursor paged; `from` and `to` are epoch milliseconds. Shape copied from roles/audit-routes.ts. */
import type { ApiClient } from "./client";

export interface AuditEntry {
  id: string; at: number; actorPersonId: string | null; actorStaffId: string | null; branchId: string | null;
  action: string; entity: string | null; entityId: string | null; before: unknown; after: unknown; ip: string | null; requestId: string | null;
}
export interface AuditQuery { actorStaffId?: string; entity?: string; from?: number; to?: number; cursor?: string | null }
export const AUDIT_PAGE = 50;

export const listAudit = (c: ApiClient, q: AuditQuery = {}) =>
  c.get<{ entries: AuditEntry[]; nextCursor: string | null }>("/audit", { limit: AUDIT_PAGE, ...q });

/** Staff names for the actor filter. Needs `staff:view`; callers treat a refusal as "no filter by person". */
export const listStaffNames = (c: ApiClient) => c.get<{ staff: { id: string; name: string }[] }>("/staff", { limit: 200 }).then((r) => r.staff);
